/* global $ */

import { Controller } from 'stimulus';
import jump from 'jump.js';

const toArray = (nodes) => Array.prototype.slice.call(nodes);

class DocumentController extends Controller {
  static fetchPage(url) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        success: resolve,
        error: reject,
      });
    });
  }

  static parsePage(htmlResponse) {
    const parser = new DOMParser();
    return parser.parseFromString(htmlResponse, 'text/html');
  }

  static updateURL(url) {
    if (typeof window.history.replaceState === 'function') {
      window.history.replaceState(null, null, url);
    }
  }

  connect() {
    this.highlightSearch();
  }

  onChapterClick(event) {
    event.preventDefault();

    const url = event.currentTarget.href;

    this.changeActiveStateTo(event.currentTarget);

    this.showSpinner();

    DocumentController.fetchPage(url)
      .then(DocumentController.parsePage.bind(this))
      .then(this.outputPage.bind(this))
      .then(this.notifyDocumentChangeToChapterBar.bind(this))
      .then(this.hideSpinner.bind(this))
      .then(() => {
        DocumentController.updateURL(url);
      });
  }

  outputPage(documentNode) {
    // Find wrappper in HTML response node
    const contentSection = documentNode.querySelector('.document-page');

    // Output to on page wrapper element
    this.element.querySelector('.document-page').innerHTML = contentSection.innerHTML;
  }

  changeActiveStateTo(target) {
    const chapters = this.element.querySelector('#chapters');

    toArray(chapters.querySelectorAll('.is-active')).forEach((activeElement) => {
      activeElement.classList.remove('is-active');
    });

    target.classList.add('is-active');
    target.closest('li').classList.add('is-active');
  }

  notifyDocumentChangeToChapterBar() {
    const chapterBar = this.element.querySelector('[data-controller="chapter-bar"]');

    const controller = this.application.getControllerForElementAndIdentifier(chapterBar, 'chapter-bar');

    controller.onDocumentChange();
  }

  showSpinner() {
    this.loadingSpinnerTarget.classList.add('is-visible');
  }

  hideSpinner() {
    this.loadingSpinnerTarget.classList.remove('is-visible');
  }

  highlightSearch() {
    const { hash } = window.location;

    if (hash && hash.indexOf('search=') >= 0) {
      const search = hash.replace('#search=', '');

      this.highlightInContent(search.split(' '));
      this.scrollToFirstMarkedWord();
    }
  }

  highlightInContent(words) {
    const pNodes = toArray(this.element.querySelectorAll('p'));

    pNodes.forEach((node) => {
      words.forEach((word) => {
        const regex = new RegExp(word, 'ig');
        node.innerHTML = node.innerHTML.replace(regex, `<mark class="js-marked-search">${word}</mark>`);
      });
    });
  }

  scrollToFirstMarkedWord() {
    const firstMarkedSearch = this.element.querySelector('.js-marked-search');

    if (firstMarkedSearch) {
      jump(firstMarkedSearch, {
        offset: -80,
      });
    }
  }
}

DocumentController.targets = [
  'chapterLink',
  'loadingSpinner',
];

export default DocumentController;
